export function historyAuthor(row, users = [], results = []) {
  const result = results.find(result => row.resultId && String(result.id || result._id) === String(row.resultId));
  const linkedAuthor = result && (result.actorName || result.authorName || result.recordedBy || result.createdBy || result.actorId || result.userId || result.details?.actorName);
  const person = row.actorName || row.authorName || row.actor || row.author || row.createdBy || linkedAuthor || row.taskCreator || row.data?.actorName || row.data?.createdBy || row.recordedBy || row.actorId || row.userId || row.details?.actorName || linkedAuthor;
  if (!person) return "Auteur non renseigné";
  if (typeof person === "object") {
    const name = person.name || [person.firstname, person.lastname].filter(Boolean).join(" ") || person.username;
    if (name) return name;
  }
  const id = String(person?._id || person?.id || person);
  const user = users.find(user => String(user._id || user.id) === id);
  if (user) return user.name || [user.firstname,user.lastname].filter(Boolean).join(" ") || "Auteur non renseigné";
  return /^[a-f0-9]{24}$/i.test(id) ? "Auteur non renseigné" : id;
}
